import Vue from 'vue'
import Vuetify, {
  VCarouselTransition,
  VCarouselReverseTransition,
  VDialogTransition,
  VDialogBottomTransition,
  VFabTransition,
  VFadeTransition,
  VMenuTransition,
  VScaleTransition,
  VScrollXTransition,
  VScrollXReverseTransition,
  VScrollYTransition,
  VScrollYReverseTransition,
  VSlideXTransition,
  VSlideXReverseTransition,
  VSlideYTransition,
  VSlideYReverseTransition,
  VTabReverseTransition,
  VTabTransition,
  VExpandTransition,
  VExpandXTransition
} from 'vuetify/lib'

// usage: https://vuetifyjs.com/
Vue.use(Vuetify, {
  components: {
    VCarouselTransition,
    VCarouselReverseTransition,
    VDialogTransition,
    VDialogBottomTransition,
    VFabTransition,
    VFadeTransition,
    VMenuTransition,
    VScaleTransition,
    VScrollXTransition,
    VScrollXReverseTransition,
    VScrollYTransition,
    VScrollYReverseTransition,
    VSlideXTransition,
    VSlideXReverseTransition,
    VSlideYTransition,
    VSlideYReverseTransition,
    VTabReverseTransition,
    VTabTransition,
    VExpandTransition,
    VExpandXTransition
  }
})

const opts = {
  theme: { disable: true }
}

export default new Vuetify(opts)
